import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import { textStyle } from '../../styles/mixins/_commonPageContentStyles';
import ExternalLinkStyled from '../ExternalLink';

interface ExternalLinkProps {
  className?: string;
  title?: string;
  cards?: {
    title: string;
    subtitle: string;
    linkUrl: string;
  }[];
}

const DEFAULT_EXTERNAL_LINK_GROUP_CARDS: NonNullable<ExternalLinkProps['cards']> = [];

const ExternalLinkGroup = ({
  title = '',
  cards = DEFAULT_EXTERNAL_LINK_GROUP_CARDS,
  className = '',
}: ExternalLinkProps) => (
  <div className={className}>
    {title && (
      <div>
        <h3 className="title-group">{title}</h3>
      </div>
    )}
    <div className="group">
      {cards?.map((card) => (
        <ExternalLinkStyled
          key={uuidv4()}
          title={card.title}
          subtitle={card.subtitle}
          linkUrl={card.linkUrl}
        />
      ))}
    </div>
  </div>
);

const ExternalLinkGroupStyled = styled(ExternalLinkGroup)`
  position: relative;

  .title-group {
    ${textStyle('h3Sb')}
    color: ${({ theme }) => theme.neutralText};
    margin-top: 0;
    margin-bottom: 1.5rem;
  }

  /* The Figma Resources list wraps cards of a third of the 1000px column. A track is a third of the
     container (less the two gaps) and never narrower than 18rem, so a wide column holds three cards
     per row and a narrow one wraps to two or one. */
  .group {
    display: grid;
    gap: 1rem;
    margin-bottom: 2.5rem;
    grid-template-columns: repeat(auto-fill, minmax(max(18rem, calc((100% - 2rem) / 3)), 1fr));
  }
`;

export default ExternalLinkGroupStyled;
